import React, { forwardRef } from 'react';
import { Base } from '../../Base.js';
import { DefaultIcon } from './DefaultIcon.js';

const Menu = forwardRef(
  ({ className, style, kind, ...props }, forwardedRef) => /* @__PURE__ */ React.createElement(
    Base,
    {
      ...props,
      ref: forwardedRef,
      className,
      style,
      kind,
      icon: /* @__PURE__ */ React.createElement(DefaultIcon, null),
      hasIconDefaultTransparency: false
    }
  )
);
Menu.displayName = "BabyButton.Menu";

export { Menu };
//# sourceMappingURL=index.js.map
